import { render, staticRenderFns } from "./AddItemOption.vue?vue&type=template&id=089d4b65"
import script from "./AddItemOption.vue?vue&type=script&lang=js"
export * from "./AddItemOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports